import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { ENDPOINTS } from '../constants/endpoints';

export interface UpgradeRequestPayload {
  name: string;
  email: string;
  message: string;
  organisationId: number;
}

async function submitUpgradeRequest(payload: UpgradeRequestPayload) {
  const response = await apiFetch(ENDPOINTS.UPGRADE_REQUEST, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  if (response.ok) return;

  const body = await response.json().catch(() => ({}));
  throw new Error(body.message ?? 'Upgrade request failed');
}

export const useUpgradeRequest = () => {
  return useMutation({ mutationFn: submitUpgradeRequest });
};
